export function countryCode2name(countryCode: string) {
  try {
    if (!Intl) return "";
    // @ts-ignore
    if (!Intl.DisplayNames) return "";
    // @ts-ignore
    const regionNames = new Intl.DisplayNames(["en"], { type: "region" });
    return regionNames.of(countryCode);
  } catch (err) {
    return countryCode;
  }
}
